<span class="brand" [class.brand--stacked]="variant === 'stacked'">
  @if (src(); as logoSrc) {
    <img class="brand__logo" [src]="logoSrc" alt="Kalaburagi Sports Habba" (error)="onError()" />
  } @else if (!hideFallback) {
    <!-- Fallback lockup, used until the real logo file is dropped into public/ -->
    <span class="brand__mark" aria-hidden="true">KSH</span>
    <span class="brand__words">
      <span class="brand__line-1">Kalaburagi</span>
      <span class="brand__line-2">Sports Habba</span>
    </span>
  }
</span>
